// extracted by mini-css-extract-plugin
export default {"container":"style_container__yZ4zY","loader":"style_loader__x4AYS","loaderAnimate":"style_loaderAnimate__535Ku","loaderBig":"style_loaderBig__4umoD"};